<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <el-button type="primary" size="small" @click="addClassify"
          >新建桌位类型</el-button
        >
        <!-- <el-button type="primary" size="small" @click="bulkUpload">批量上传商品</el-button>
                <el-button type="text" size="small" @click="downloadTemp" class="fix-middle">
                    <i class="iconfont iconxiazai-copy"></i>下载商品模板
                </el-button>-->
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="classifyList" style="width: 100%">
            <el-table-column label="桌位类型">
              <template slot-scope="scope">
                <div class="tag-name">
                  {{ scope.row.tableConfigName }}({{ scope.row.min }}-{{
                    scope.row.max
                  }}人)
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button size="small" type="primary" @click="edit(scope.$index)" plain
                    >编辑</el-button
                  >
                  <el-button
                    size="small"
                    plain
                    @click="delEdcShopTableConfig(scope.row.shoppingTableConfigId)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogAddClassifyVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        {{ addClassifyForm.shoppingTableConfigId ? "编辑桌位类型" : "新建桌位类型" }}
      </div>
      <el-form
        :model="addClassifyForm"
        :rules="addClassifyFormRule"
        ref="addClassifyForm"
        label-width="68px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="桌位类型" prop="tableConfigName">
          <el-input
            v-model="addClassifyForm.tableConfigName"
            :maxlength="15"
            placeholder="请填写桌位名称（如小桌，中桌）"
          ></el-input>
        </el-form-item>
        <el-form-item label="人数选择">
          <el-input-number
            v-model="addClassifyForm.min"
            controls-position="right"
            :min="1"
            :max="2147483647"
          ></el-input-number>
          <span style="margin: 0 17px">-</span>
          <el-input-number
            v-model="addClassifyForm.max"
            controls-position="right"
            :min="1"
            :max="2147483647"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="等待时间" prop="waitingTime">
          <el-input-number
            v-model="addClassifyForm.waitingTime"
            controls-position="right"
            :min="1"
            :max="2147483647"
          ></el-input-number>
          <span style="margin: 0 17px">分钟</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createClassify" :loading="isSubmit">{{
          addClassifyForm.shoppingTableConfigId ? "立即编辑" : "立即创建"
        }}</el-button>
        <el-button @click="dialogAddClassifyVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getShopTableConfigs,
  updateEdcShopTableConfig,
  delEdcShopTableConfig,
  getShopTableConfigsNum,
} from "@/api";
export default {
  data() {
    return {
      classifyList: [],
      pageSize: 5,
      pageCount: 0,
      pageNo: 1,
      dialogAddClassifyVisible: false,
      addClassifyForm: {
        min: "1",
        max: "2",
        tableConfigName: "",
        shoppingTableConfigId: "",
        waitingTime: 1,
      },
      addClassifyFormRule: {
        tableConfigName: [
          {
            required: true,
            message: "请填写桌位类型",
            trigger: "blur",
          },
        ],
        min: [
          {
            required: true,
            message: "请填写最小人数",
            trigger: "blur",
          },
        ],
        max: [
          {
            required: true,
            message: "请填写最大人数",
            trigger: "blur",
          },
        ],
        waitingTime: [
          {
            required: true,
            message: "请填写等待时间",
            trigger: "blur",
          },
        ],
      },
      isSubmit: false,
    };
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.getShopTableConfigs();
      this.getShopTableConfigsNum();
    },
    getShopTableConfigs() {
      getShopTableConfigs({
        pageNo: this.pageNo,
        row: this.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          this.classifyList = res.data;
        } else {
          this.classifyList = [];
        }
      });
    },
    getShopTableConfigsNum() {
      getShopTableConfigsNum({}).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
          if (this.pageNo > this.pageCount / this.pageSize) {
            this.pageNo = Math.ceil(this.pageCount / this.pageSize);
            this.getShopTableConfigs();
          }
        }
      });
    },
    addClassify() {
      this.addClassifyForm = {
        min: "1",
        max: "2",
        tableConfigName: "",
        shoppingTableConfigId: "",
        waitingTime: 1,
      };
      this.dialogAddClassifyVisible = true;
    },
    updateEdcShopTableConfig(params) {
      this.isSubmit = true;
      updateEdcShopTableConfig(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: params.shoppingTableConfigId ? "编辑成功" : "新增成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
          this.dialogAddClassifyVisible = false;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
        setTimeout(() => {
          this.isSubmit = false;
        }, 500);
      });
    },
    delEdcShopTableConfig(id) {
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delEdcShopTableConfig({
              shoppingTableConfigId: id,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    createClassify() {
      this.$refs.addClassifyForm.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.addClassifyForm));
          this.updateEdcShopTableConfig(params);
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getShopTableConfigs();
    },
    edit(index) {
      this.addClassifyForm = JSON.parse(JSON.stringify(this.classifyList[index]));
      this.dialogAddClassifyVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-content {
    display: block;
    padding: 0 20px;
  }
}
.el-input-number {
  width: 160px;
  .el-input__inner {
    padding: 0 24px;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    width: 24px;
    box-sizing: border-box;
  }
}
</style>
